import React from 'react';
import classnames from 'classnames';
import _get from 'lodash/get';

export default function SkinTypeItem({
  categoryKey,
  detectionMapping,
  activeDetection,
  setActiveDetection,
  isLandscape,
  activeLang,
}) {
  return (
    <div
      className={classnames({
        'skincaredetectionpreview-detections__detection': true,
        'skincaredetectionpreview-detections__detection--landscape': isLandscape,
      })}
    >
      <img
        src={`${_get(detectionMapping, `${categoryKey}.icon`, '#ccc')}`}
        alt="detection-icon"
        className={classnames({
          'cursor-pointer': true,
          'skincaredetectionpreview-detections__detection-icon': true,
        })}
        style={{
          border: `3px solid ${_get(
            detectionMapping,
            `${categoryKey}.color`,
            '#ccc'
          )}`,
          backgroundColor:
            activeDetection === categoryKey
              ? _get(detectionMapping, `${categoryKey}.color`, '#ccc')
              : 'rgba(255,255,255,0.3)',
        }}
        onClick={() => setActiveDetection(categoryKey)}
      />
      <div
        className={classnames({
          'skincaredetectionpreview-detections__detection-name': true,
          'skincaredetectionpreview-detections__detection-name--landscape': isLandscape,
        })}
      >
        {_get(detectionMapping, `${categoryKey}.categoryI18n.${activeLang}`)}
        <br />
        {_get(
          detectionMapping,
          `${categoryKey}.labelI18n.${activeLang}`,
          detectionMapping[categoryKey].label
        )}
      </div>
    </div>
  );
}
